<template>
	<section class="relativeclass">
		<div
			class="singleCheckbox-class d-flex align-items-center w-100"
			:class="{ 'class-for-lineheight': lineH }"
		>
			<b-form-checkbox v-model="isChecked" @change="updateValue">
				<span v-html="label"></span>
			</b-form-checkbox>
		</div>
	</section>
</template>

<script>
export default {
	name: "SingleCheckbox",
	props: {
		label: {
			type: String,
			default: "Checkbox",
		},
		value: {
			type: Boolean,
			default: false,
		},
		lineH: {
			type: Boolean,
		},
	},
	data() {
		return {
			isChecked: this.value,
		};
	},
	methods: {
		updateValue() {
			this.$emit("input", this.isChecked);
		},
	},
	watch: {
		value(newVal) {
			this.isChecked = newVal;
		},
	},
};
</script>
<style>
.singleCheckbox-class .custom-control-label {
	font-family: var(--lato);
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: #3a3c40;
	vertical-align: middle;
	cursor: pointer;
}
.class-for-lineheight .custom-control-label {
	line-height: 16px;
	padding-top: 2px;
}
.class-for-lineheight .custom-control {
	padding-top: 2px;
}
.singleCheckbox-class
	.custom-control-input:focus:not(:checked)
	~ .custom-control-label::before {
	border-color: var(--navy-blue);
}

.singleCheckbox-class
	.custom-control-input:focus
	~ .custom-control-label::before {
	box-shadow: none;
}
.singleCheckbox-class .custom-control-input {
	height: var(--size-16);
	width: 17px;
	top: 4px;
	left: 0px;
	cursor: pointer;
}

.singleCheckbox-class .custom-checkbox .custom-control-label::before {
	height: var(--size-16);
	width: var(--size-16);
	border-radius: 2px;
	border: 2px solid var(--navy-blue);
	top: 3px;
}

.singleCheckbox-class .custom-checkbox .custom-control-label::after {
	height: var(--size-16);
	width: var(--size-16);
	border-radius: 2px;
	top: 3px;
}

.singleCheckbox-class
	.custom-control-input:focus:not(:checked)
	~ .custom-control-label::before {
	border-color: var(--navy-blue);
}

.singleCheckbox-class
	.custom-control-input:checked
	~ .custom-control-label::before {
	background-color: var(--navy-blue);
}

.singleCheckbox-class
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-color: var(--navy-blue);
}

.singleCheckbox-class
	.custom-control-input:focus
	~ .custom-control-label::before {
	box-shadow: none !important;
}
</style>
